import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWandSparkles = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M21.64 3.64005L20.36 2.36004C20.2475 2.24636 20.1135 2.15612 19.9659 2.09452C19.8183 2.03293 19.6599 2.00122 19.5 2.00122C19.3401 2.00122 19.1817 2.03293 19.0341 2.09452C18.8865 2.15612 18.7525 2.24636 18.64 2.36004L2.36 18.64C2.24632 18.7526 2.15607 18.8865 2.09448 19.0341C2.03289 19.1817 2.00117 19.3401 2.00117 19.5C2.00117 19.66 2.03289 19.8184 2.09448 19.966C2.15607 20.1136 2.24632 20.2475 2.36 20.36L3.64 21.64C3.75182 21.755 3.88553 21.8463 4.03324 21.9087C4.18095 21.971 4.33966 22.0031 4.5 22.0031C4.66033 22.0031 4.81904 21.971 4.96675 21.9087C5.11446 21.8463 5.24818 21.755 5.36 21.64L21.64 5.36005C21.7549 5.24822 21.8462 5.11451 21.9086 4.9668C21.971 4.81909 22.0031 4.66038 22.0031 4.50005C22.0031 4.33971 21.971 4.181 21.9086 4.03329C21.8462 3.88558 21.7549 3.75187 21.64 3.64005Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 7L17 10",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 6V10",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 14V18",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 2V4",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 8H3",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 16H17",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 3H9",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgWandSparkles);
export default ForwardRef;
